export default __webpack_public_path__ + "static/media/Product-Stock.4185d3e7.jpg";